
<template>
  <router-btn v-if="showNewTimeReport" :text="$t('servicesystem.common_objects.commonterms.export')"
              :icon="'mdi-microsoft-excel'"
              :color="exportValid ? 'primary' : 'disabled'"
              :disabled="false"
              :outlined="false"
              :textbtn="textbtn"
              :large="large"
              :small="small"
              @Press="action()">
  </router-btn>
</template>


<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "ExportBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  methods: {
    action() {
      if (this.exportValid) {
        this.$store.state.triggerevents.exportTrigger++;
      }
    },
  },

  computed: {
    showNewTimeReport(){
      return this.$store.state.GlobalSettings.ShowNewTimeReport;
    },

    exportValid() {
      return this.$store.state.triggerevents.exportValid;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
</style>
